export default __webpack_public_path__ + "static/media/FilledGridExample.7b5b0eb2.png";